var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { CurrencyOption } from './CurrencyOption';
import { ListModal } from '../Modals/ListModal';
export var CurrencyModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, label = _a.label, onChange = _a.onChange, currencies = _a.currencies, searchEnabled = _a.searchEnabled, searchPlaceholder = _a.searchPlaceholder, currency = _a.currency, hideProtocol = _a.hideProtocol;
    var filterCurrencies = useMemo(function () {
        return searchEnabled
            ? function (currency, searchString) {
                var code = Array.isArray(currency)
                    ? currency[0].code.toLowerCase()
                    : currency.code.toLowerCase();
                var names = Array.isArray(currency)
                    ? currency.map(function (item) { return item.name.toLowerCase(); })
                    : [currency.name.toLowerCase()];
                var values = __spreadArray(__spreadArray([], names, true), [code], false);
                return values.some(function (value) {
                    return value.includes(searchString.toLowerCase());
                });
            }
            : undefined;
    }, [searchEnabled]);
    var renderCurrencyItemElement = useCallback(function (item, index) {
        return (_jsx(CurrencyOption, { hideProtocol: hideProtocol, onCurrencySelect: onChange, currency: item, selectedCurrency: currency }, index));
    }, [hideProtocol, onChange, currency]);
    return (_jsx(ListModal, { searchPlaceholder: searchPlaceholder, onClose: onClose, label: label, isOpen: isOpen, list: currencies, filterItems: filterCurrencies, renderItems: renderCurrencyItemElement }));
};
